import { useQuery } from 'data-fetching-client';
import { GET_DEAL_PIPELINE, GET_DEAL_PIPELINE_FIELD } from '../api/dataFetchingQueries';
export const useFetchSpecificPipelineStages = pipelineId => {
  var _data$GET_DEAL_PIPELI;
  const {
    data,
    loading,
    error
  } = useQuery(GET_DEAL_PIPELINE, {
    variables: {
      pipelineId
    }
  });
  return {
    data: data === null || data === void 0 || (_data$GET_DEAL_PIPELI = data[GET_DEAL_PIPELINE_FIELD]) === null || _data$GET_DEAL_PIPELI === void 0 ? void 0 : _data$GET_DEAL_PIPELI.stages,
    loading,
    error
  };
};